import Entity from "./entity";
import TeamMember from "./team-member";
import TeamInvitation from "./team-invitation";

export default class Team extends Entity<string> {
  name: string;
  color: string;
  completedPercentage: number;
  content: string;
  contentVersion: number;
  hashTags: string;
  description: string;
  archived: boolean;
  members: TeamMember[];
  invitations: TeamInvitation[];
  grantedPermissions;
}
